import React, { useContext, useEffect, useState } from 'react';
import {
    Modal, ModalHeader, ModalBody, Form, Row, Col,
    FormGroup, Label, Input, Button
} from 'reactstrap';
import Select from 'react-select';
import { AuthContext } from '../../context/AuthContext';
import { ContaPagarContext } from '../../context/ContaPagarContext';
import { ContaFinanceiraContext } from '../../context/ContaFinanceiraContext';
import { CategoriaFinanceiraContext } from '../../context/CategoriaFinanceiraContext';
import { FormaPagamentoContext } from '../../context/FormaPagamentoContext';
import { TipoContaPagarContext } from '../../context/TipoContaPagarContext';
import { UpdateContaPagarType } from '../../context/hooks/useContaPagar';

import { CurrencyInput } from '../Form/CurrencyInput';

interface Props {
    isOpen: boolean;
    toggle: () => void;
    conta: UpdateContaPagarType | null;
    onUpdated?: () => void;
}

export const EditContaPagarModal: React.FC<Props> = ({ isOpen, toggle, conta, onUpdated }) => {
    const { updateContaPagar, getContaPagarAttachment } = useContext(ContaPagarContext);
    const { objUserTk } = useContext(AuthContext);
    const { handleGetContaFinanceiraByEmpresaId, listContaFinanceiraByEmpresa } = useContext(ContaFinanceiraContext);
    const { handleGetCategoriaFinanceiraByEmpresaId, listCategoriaFinanceiraByEmpresa } = useContext(CategoriaFinanceiraContext);
    const { handleGetFormaPagamentoByEmpresaId, listFormaPagamentoByEmpresa } = useContext(FormaPagamentoContext);
    const { handleGetTipoContaPagarByEmpresaId, listTipoContaPagarByEmpresa } = useContext(TipoContaPagarContext);

    const [form, setForm] = useState<UpdateContaPagarType | null>(null);

    useEffect(() => {
        if (!listContaFinanceiraByEmpresa.length) handleGetContaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        if (!listCategoriaFinanceiraByEmpresa.length) handleGetCategoriaFinanceiraByEmpresaId(objUserTk.EmpresaId);
        if (!listFormaPagamentoByEmpresa.length) handleGetFormaPagamentoByEmpresaId(objUserTk.EmpresaId);
        if (!listTipoContaPagarByEmpresa.length) handleGetTipoContaPagarByEmpresaId(objUserTk.EmpresaId);
    }, []);

    // useEffect(() => {
    //     if (isOpen && conta) setForm({ ...conta });
    // }, [isOpen, conta]);

    useEffect(() => {
        if (isOpen && conta) {
            setForm({ ...conta });
        }
    }, [isOpen, conta]);

    if (!form) return null;

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setForm(prev => prev ? { ...prev, [name]: value } : prev);
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!form) return;
        const ok = await updateContaPagar({
            ...form,
            valor: +form.valor,
            taxa: +form.taxa,
            codigoTransacao: +form.codigoTransacao
        });
        if (ok) {
            onUpdated?.();
            toggle();
        }
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            setForm(prev => ({
                ...prev!,
                receiptAttachment: reader.result as string,
            }));
        };
        reader.onerror = (error) => {
            console.error("Erro ao ler arquivo:", error);
        };
    };

    const contaOpts = listContaFinanceiraByEmpresa.map(c => ({ value: c.id, label: c.name }));
    const catOpts = listCategoriaFinanceiraByEmpresa.map(c => ({ value: c.id, label: c.name }));
    const formaOpts = listFormaPagamentoByEmpresa.map(f => ({ value: f.id, label: f.name }));
    const tipoOpts = listTipoContaPagarByEmpresa.map(tp => ({ value: tp.id, label: tp.name }));

    return (
        <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg">
            <ModalHeader toggle={toggle}>Editar informações da conta</ModalHeader>
            <ModalBody>
                <Form onSubmit={handleSubmit}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Valor</Label>
                                <CurrencyInput
                                    name="valor"
                                    value={form.valor}
                                    onValueChange={v => setForm(prev => prev ? { ...prev, valor: v } : prev)}
                                    placeholder="R$ 0,00"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Taxa</Label>
                                <CurrencyInput
                                    name="taxa"
                                    value={form.taxa}
                                    onValueChange={v => setForm(prev => prev ? { ...prev, taxa: v } : prev)}
                                    placeholder="R$ 0,00"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Vencimento</Label>
                                <Input className="form-control-alternative" type="date" name="vencimento"
                                    value={new Date(form.vencimento).toISOString().split('T')[0]} onChange={onChange} required />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Documento</Label>
                                {/* <Input className="form-control-alternative" name="documento"
                                    value={form.documento} onChange={onChange} /> */}
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="documento"
                                    value={form.documento}
                                    onChange={onChange}
                                    placeholder="Número do documento"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Código Transação</Label>
                                {/* <Input className="form-control-alternative" type="number" name="codigoTransacao"
                                    value={form.codigoTransacao} onChange={onChange} /> */}
                                <Input
                                    className="form-control-alternative"
                                    type="number"
                                    name="codigoTransacao"
                                    value={form.codigoTransacao}
                                    onChange={onChange}
                                    placeholder="Código da transação"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Histórico</Label>
                                {/* <Input className="form-control-alternative" name="historico"
                                    value={form.historico} onChange={onChange} /> */}
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="historico"
                                    value={form.historico}
                                    onChange={onChange}
                                    placeholder="Histórico da transação"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Bandeira</Label>
                                {/* <Input className="form-control-alternative" name="bandeira"
                                    value={form.bandeira} onChange={onChange} /> */}
                                <Input
                                    className="form-control-alternative"
                                    type="text"
                                    name="bandeira"
                                    value={form.bandeira}
                                    onChange={onChange}
                                    placeholder="Bandeira do cartão ou meio de pagamento"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Conta Financeira</Label>
                                <Select
                                    className="form-control-alternative"
                                    options={contaOpts}
                                    value={contaOpts.find(f => f.value === form.contaFinanceiraId)}
                                    onChange={opt => setForm(prev => prev ? { ...prev, contaFinanceiraId: opt ? opt.value : 0 } : prev)}
                                    isClearable
                                    classNamePrefix="react-select"
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Categoria Financeira</Label>
                                <Select
                                    className="form-control-alternative"
                                    options={catOpts}
                                    value={catOpts.find(f => f.value === form.categoriaFinanceiraId)}
                                    onChange={opt => setForm(prev => prev ? { ...prev, categoriaFinanceiraId: opt ? opt.value : 0 } : prev)}
                                    isClearable
                                    classNamePrefix="react-select"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Forma de Pagamento</Label>
                                <Select
                                    className="form-control-alternative"
                                    options={formaOpts}
                                    value={formaOpts.find(f => f.value === form.formaPagamentoId)}
                                    onChange={opt => setForm(prev => prev ? { ...prev, formaPagamentoId: opt ? opt.value : 0 } : prev)}
                                    isClearable
                                    classNamePrefix="react-select"
                                    placeholder="Selecione uma forma de pagamento"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label className="form-control-label">Tipo de Conta Pagar</Label>
                                <Select
                                    className="form-control-alternative"
                                    options={tipoOpts}
                                    value={tipoOpts.find(f => f.value === form.tipoContaPagarId)}
                                    onChange={opt => setForm(prev => prev ? { ...prev, tipoContaPagarId: opt ? opt.value : 0 } : prev)}
                                    isClearable
                                    classNamePrefix="react-select"
                                    placeholder="Selecione o tipo de conta a pagar"
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label className="form-control-label" htmlFor="receiptAttachment">
                                    Anexo do Recibo (PDF)
                                </Label>
                                <Input
                                    className="form-control-alternative"
                                    type="file"
                                    name="receiptAttachment"
                                    id="receiptAttachment"
                                    accept=".pdf"
                                    onChange={handleFileChange}
                                />
                                {form.hasReceiptAttachment && (
                                    <div className="alert alert-success d-flex align-items-center mt-2" role="alert">
                                        <i className="fa-solid fa-file-lines fa-lg mr-2"></i>
                                        <div className="d-flex justify-content-between w-100 align-items-center">
                                            <span className="font-weight-bold">
                                                Um recibo está anexado a esta conta.
                                            </span>
                                            <Button
                                                color="primary"
                                                size="sm"
                                                onClick={() => getContaPagarAttachment(form.id)}
                                                className="ml-3"
                                            >
                                                <i className="fa-solid fa-eye mr-1"></i> Visualizar Recibo
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </FormGroup>
                        </Col>
                    </Row>
                    <div className="d-flex justify-content-end mt-3">
                        <Button style={{ background: '#585858', color: '#fff' }} type="submit">Salvar alterações</Button>
                        <Button style={{ background: '#585858', color: '#fff' }} className="ml-2" onClick={toggle}>Cancelar</Button>
                    </div>
                </Form>
            </ModalBody>
        </Modal>
    );
};
export default EditContaPagarModal;